/* eslint no-param-reassign: "off" */

import ElementUpdater from './elementUpdater'
import Selector from './selector'

const updateEditMode = () => {
  const editModeBackgroundImageWrapperTextSlideSelector =
    '.presentation_editor_show .presentation_slide.text_slide .slide_background_image_wrapper'
  const editModeFooterSelector = '.presentation_editor_show .pres_editor_footer'
  const editModeDaySlideContentsSelector =
    '.presentation_editor_show .presentation_slide.content_wall_slide .slide_contents'
  const editModeSingleMomentBackgroundImageSelector =
    '.presentation_editor_show .presentation_slide.single_moment_slide .slide_background_image_wrapper'
  const editingMomentsRegionSelector =
    '.presentation_editor .content_wall_slide .moments_region'
  const editingMomentsRegionHeader =
    '.presentation_editor .content_wall_slide .moments_region_header'
  const editModeWeekViewTsStreamSegments =
    '.presentation_editor_show .presentation_slide.week_view_slide .ts_stream_segments'

  const selectors = [
    new Selector({
      selection: editModeBackgroundImageWrapperTextSlideSelector,
    }),
    new Selector({
      selection: editModeFooterSelector,
    }),
    new Selector({
      selection: editModeDaySlideContentsSelector,
    }),
    new Selector({
      selection: editModeSingleMomentBackgroundImageSelector,
    }),
    new Selector({
      selection: editingMomentsRegionSelector,
    }),
    new Selector({
      selection: editingMomentsRegionHeader,
    }),
    new Selector({
      selection: editModeWeekViewTsStreamSegments,
    }),
  ]

  const updateStyles = () => {
    // Allows editable description
    document
      .querySelectorAll(editModeBackgroundImageWrapperTextSlideSelector)
      .forEach((element) => {
        element.style['z-index'] = -1
      })

    document.querySelectorAll(editModeFooterSelector).forEach((element) => {
      element.style['z-index'] = '10'
    })

    document
      .querySelectorAll(editModeDaySlideContentsSelector)
      .forEach((element) => {
        element.style['z-index'] = 0
      })

    document.querySelectorAll(editingMomentsRegionHeader).forEach((element) => {
      element.style.height = '68px'
      element.style.top = '229px'
      element.style.display = 'flex'
      element.style['justify-content'] = 'space-between'
      element.style['align-items'] = 'center'
    })

    let hasHeader = 0
    if (document.querySelectorAll('.kuiper-presentations-header'))
      hasHeader = 80

    document
      .querySelectorAll(editModeWeekViewTsStreamSegments)
      .forEach((element) => {
        element.style.top = `calc(180px + ${hasHeader}px`
      })
  }

  const updater = new ElementUpdater(selectors, updateStyles)
  updater.update()
}

export default updateEditMode
